import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { SavedPrescriptionsPatient } from "../../Apis/AuthApiServices";
import {
  loadingSavedPrescriptions,
  setSavedPrescriptions,
} from "../Slice/SavedPrescriptionSlice";

function* onLoadSavedPrescriptionsAsync({ payload }: any) {
  const params = new URLSearchParams();
  params.append("doctorId", payload.doctorId);
  params.append("patientId", payload.patientId);
  params.append("pageNumber", payload.pageNumber);

  try {
    const result: AxiosResponse = yield SavedPrescriptionsPatient(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setSavedPrescriptions({
          savedPrescriptionData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setSavedPrescriptions({
          savedPrescriptionData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error) {
    yield put(
      setSavedPrescriptions({
        savedPrescriptionData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some time!",
      })
    );
  }
}

function* onLoadSavedPrescriptions() {
  yield takeLatest(
    loadingSavedPrescriptions.type,
    onLoadSavedPrescriptionsAsync
  );
}

const SavedPrescriptionsSaga = [fork(onLoadSavedPrescriptions)];
export default SavedPrescriptionsSaga;
